/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ProfileCard from "../../ProfileCard";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import "./Sidebar.css";

const SidebarWorker = ({ showSideBar, setShowSideBar }) => {
  const worker = useSelector((state) => state.workerReducer);
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const orders = useSelector((state) => state.OrdersReducer);

  const [data, setData] = useState("");
  const [data2, setData2] = useState("");
  const location = useLocation();
  const { t } = useTranslation();
  const dir = i18n.dir();
  const currentLang = i18n.language;
  const isRtl = dir === "rtl";

  useEffect(() => {
    setData(worker);
    setData2(store);
  }, [worker, store]);  

  const permissions = worker?.permissions || {};
  const canViewAbndnOrders = permissions["orders.view"] === true;
  const canViewOrders = permissions["orders.view"] === true;
  const canViewProducts = permissions["products.view"] === true;
  const canViewStore = permissions["store.view"] === true;
  const canEditProducts = permissions["products.update"] === true;
  const canEditStore = permissions["store.update"] === true;
  const canEditStoreDesign = permissions["store.updatedesign"] === true;
  
  const storeName = account?.store?.split(".")[0];
  const domain = `${storeName}.foorweb.online`;

  return (
    <div className="sidebar hidden md:flex z-50">
      <aside
        id="logo-sidebar"
        className={`fixed top-0 z-40 h-screen flex flex-col bg-white dark:!bg-[#19171A] w-[260px] ${
          dir === "rtl" ? "right-0" : "left-0"
        }`}
        aria-label={t("ui.sidebar")}
      >
        <div className="flex-1 overflow-y-auto bg-[#5a2b73] dark:!bg-[#19171A] px-0 pb-4 pt-1 sidebarScroll ">
          <div className="top-0 right-0 bg-[#5a2b73] dark:!bg-[#19171A] pb-3 pr-2 flex">
            <a href="https://foorweb.net/" className="flex items-center">
              <img
                src={
                  currentLang === "ar" ? "/LogoVersionAr.png" : "/logo-new.png"
                }
                className="h-16 sm:h-16"
                alt="Foorweb"
              />
            </a>
          </div>

          <button
            className={`absolute text-[#825ba0] top-7 ${
              dir === "rtl" ? "left-10" : "right-10"
            }`}
            onClick={() => setShowSideBar(!showSideBar)}
          >
            <i className="bi bi-dash-square-dotted text-2xl"></i>
          </button>

          <ProfileCard
            data={data}
            data2={data2}
            worker={worker}
            isRtl={isRtl}
            domain={domain}
            isWorker={true}
          />

          <ul className="space-y-1 mt-[30px] font-medium custom-scrollbar">
            <li
              className={`transition ${
                location && location.pathname === "/dashboard"
                  ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                  : "bg-[#5a2b73] dark:!bg-[#19171A]"
              }`}
            >
              <Link
                to={"/dashboard"}
                className={`flex items-center p-2 h-[51px] ${
                  location && location.pathname === "/dashboard"
                    ? "hover:bg-[#52276a]"
                    : "hover:bg-[#52276a]"
                } group`}
              >
                <div
                  className={`${
                    location && location.pathname === "/dashboard"
                      ? "text-[#dcb5f3]"
                      : "text-[#fff]"
                  }`}
                >
                  <i className="bi bi-speedometer2 mx-sm-3 mx-0 my-auto fs-5" />
                  <span className="">{t("sidebar.dashboard")}</span>
                </div>
              </Link>
            </li>

            {/* Orders - Only if worker has orders.view permission */}
            {canViewOrders &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${
                    location && location.pathname === "/team/orders"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={"/team/orders"}
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${
                      location && location.pathname === "/team/orders"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/team/orders"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-cart3 mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span>{t("sidebar.orders")}</span>
                    </div>
                    {orders.filter((order) => order.deleveryStatus === "1")
                      .length > 0 && (
                      <span className="inline-flex items-center justify-center px-2 ms-3 text-sm font-medium text-[#5a2b73] bg-[#be97d4] rounded-full pt-1">
                        {
                          orders.filter((order) => order.deleveryStatus === "1")
                            .length
                        }
                      </span>
                    )}
                  </Link>
                </li>
              )}

            {/* Digital Orders */}
            {canViewOrders &&
              digitalStore?.isActiveDigitalProducts &&
              (account?.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${
                    location?.pathname === "/team/orders/digital"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to="/team/orders/digital"
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${
                      location?.pathname === "/team/orders/digital"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location?.pathname === "/team/orders/digital"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-cart3 mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span>{t("sidebar.digitalOrders")}</span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Abandoned Orders */}
            {canViewOrders && worker.role=="partner" &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${
                    location && location.pathname === "/team/Ordersabndn"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={"/team/Ordersabndn"}
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${
                      location && location.pathname === "/team/Ordersabndn"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/team/Ordersabndn"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-cart-x-fill mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span>{t("sidebar.abndndOrders")}</span>
                    </div>
                    {orders.filter((order) => order.deleveryStatus === "20")
                      .length > 0 && (
                      <span className="inline-flex items-center justify-center px-2 ms-3 text-sm font-medium text-[#5a2b73] bg-[#be97d4] rounded-full pt-1">
                        {
                          orders.filter(
                            (order) => order.deleveryStatus === "20"
                          ).length
                        }
                      </span>
                    )}
                  </Link>
                </li>
              )}

            {/* Products */}
            {canViewProducts && (
              <li
                className={`transition ${
                  location && location.pathname === "/team/products"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link
                  to={"/team/products"}
                  className={`flex items-center p-2 h-[51px] text-white justify-between ${
                    location && location.pathname === "/team/products"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`${
                      location && location.pathname === "/team/products"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                    }`}
                  >
                    <i className="bi bi-box-seam mx-sm-3 mx-0 fs-5 my-auto" />
                    <span className="flex-1 whitespace-nowrap">
                      {t("sidebar.products")}
                    </span>
                  </div>
                </Link>
              </li>
            )}

            {/* Store Customization - Classic */}
            {canEditStore && canEditStoreDesign &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${
                    location && location.pathname === "/team/settings/store"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={`/team/settings/store`}
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location && location.pathname === "/team/settings/store"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/team/settings/store"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-palette mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.storeCostumisation")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Store Customization - Digital */}
            {canViewStore &&
              (account?.productMode ?? "classic") === "digital" && (
                <li
                  className={`transition ${
                    location &&
                    location.pathname === "/team/digital/settings/store"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={`/team/digital/settings/store`}
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location &&
                      location.pathname === "/team/digital/settings/store"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location &&
                        location.pathname === "/team/digital/settings/store"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-palette mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.storeCostumisation")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Stock */}
            {canEditProducts &&
              (account?.productMode ?? "classic") === "classic" && (
                <li
                  className={`transition ${
                    location && location.pathname === "/team/settings/stock"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={`/team/settings/stock`}
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location && location.pathname === "/team/settings/stock"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/team/settings/stock"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-collection mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.stock")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Payment Methods - Digital */}
            {canViewStore &&
              (account?.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${
                    location && location.pathname === "/payment-methods"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={`/payment-methods`}
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location && location.pathname === "/payment-methods"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/payment-methods"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-credit-card mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.paimentMethods")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

            {/* Digital Sections */}
            {canViewStore &&
              (account?.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${
                    location && location.pathname === "/digital-sections"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to={`/digital-sections`}
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location && location.pathname === "/digital-sections"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/digital-sections"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-folder-fill mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.digitalSections")}
                      </span>
                    </div>
                  </Link>
                </li>
              )}

          </ul>

          <div className="px-4 pt-6 pb-2 border-t border-[#6d3a88]">
            <h4 className="text-white text-sm font-medium mb-3 text-center">
              {t("sidebar.doxnload")}
            </h4>
            <div className="flex justify-center space-x-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.foorweb.foorwebapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/googlePlay.png"
                  alt={t("AccountSettings.twoFA.steps.downloadApp.buttons.googlePlay")}
                  className="h-10"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/foorweb/id6738890253"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/appStore.png"
                  alt={t("AccountSettings.twoFA.steps.downloadApp.buttons.appStore")}
                  className="h-10"
                />
              </a>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default SidebarWorker;
